document.addEventListener("DOMContentLoaded", () => {
    const btnClearSearch = document.querySelectorAll(".btn-clear-search");

    if (btnClearSearch.length) {
        btnClearSearch.forEach((btn) => {
            btn.addEventListener("click", () => {
                const prevElement = btn.previousElementSibling;
                console.log("====================================");
                console.log(prevElement.tagName);
                console.log("====================================");
                if (prevElement.tagName === "INPUT") {
                    prevElement.value = "";
                }
            });
        });
    }
});
